import WEEK_DAYS from '../constants/weekDays';
import {IHandoverDay} from "@components/guide/steps/stepHandover.component";

export default (originalDays: boolean[]):IHandoverDay[] => {
  const copiedDays = Array.from(originalDays);

  return copiedDays.map((day: boolean, index: number) => {

    const dayName: string = WEEK_DAYS[(index+1)%7] ;

    const ho:IHandoverDay = {
      id: index,
      hour: 13,
      minutes: 0,
      atSchool: false,
      parent: day?"ParentA":"ParentB",
      location: "",
      dayName,
    };
    return ho;
  });
};



// WEBPACK FOOTER //
// ./src/helpers/spawnHandoverDays.ts